import * as React from 'react';

import { Button } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import { DEFAULT_SORTED_VALUE, SEARCH_MAIN_INDEX_ID } from 'bundles/search-common/constants';
import { useSearch } from 'bundles/search-common/providers/SearchContext';
import { scrollUpIfNecessary } from 'bundles/search-common/utils/utils';

import _t from 'i18n!nls/search';

export const ResetFiltersAndSortButton = (): React.ReactElement => {
  const { applySearchStateUpdates, clearFilters, getSearchResults } = useSearch();
  const { sortBy } = getSearchResults(SEARCH_MAIN_INDEX_ID) || {};
  const track = useTracker();

  return (
    <Button
      aria-label={_t('Reset filters and sort')}
      variant="ghost"
      onClick={() => {
        if (sortBy !== DEFAULT_SORTED_VALUE) {
          applySearchStateUpdates(SEARCH_MAIN_INDEX_ID, { clearFilters: true, sortBy: DEFAULT_SORTED_VALUE });
        } else {
          clearFilters(SEARCH_MAIN_INDEX_ID);
        }
        scrollUpIfNecessary({ mustBeScrolledPastThisElementId: 'search-results-header-wrapper' });

        track('apply_filter', {
          filter: [],
          filterSource: 'quick_filter',
          isReset: true,
        });
      }}
    >
      {_t('Reset')}
    </Button>
  );
};

export default ResetFiltersAndSortButton;
